import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { FaChevronUp } from "react-icons/fa";
import Loader from '../../../components/Loader/Loader';
import { postWhyDidItHappen } from '../../../apiservices/ApiServices';

const WhyDidItHappen = ({ details, postUpdateData, toast }) => {
    const [isLoadings, setLoadings] = useState(false);

    const initialValues = {
        why: details?.why,
        // se_causes_json
        id: details?.why_did_happen?.id || '',
        weather: details?.why_did_happen?.se_causes_json?.weather || '',
        visibility: details?.why_did_happen?.se_causes_json?.visibility || '',
        lightingAdequacy: details?.why_did_happen?.se_causes_json?.lightingAdequacy || '',
        noiseDistraction: details?.why_did_happen?.se_causes_json?.noiseDistraction || '',
        timeOfDay: details?.why_did_happen?.se_causes_json?.timeOfDay || '',
        trafficActivity: details?.why_did_happen?.se_causes_json?.trafficActivity || '',
        emergencyOngoing: details?.why_did_happen?.se_causes_json?.emergencyOngoing || '',
        emergencyDetails: details?.why_did_happen?.se_causes_json?.emergencyDetails || '',

        // aei_causes_json
        equipmentCondition: details?.why_did_happen?.aei_causes_json?.equipment_condition || '',
        maintenanceStatus: details?.why_did_happen?.aei_causes_json?.maintenance_status || '',
        assetType: details?.why_did_happen?.aei_causes_json?.asset_type || '',
        assetId: details?.why_did_happen?.aei_causes_json?.asset_tag || '',
        knownDefects: details?.why_did_happen?.aei_causes_json?.known_defects || '',
        knownDefectsDetails: details?.why_did_happen?.aei_causes_json?.known_defects_detail || '',
        assetFitForUse: details?.why_did_happen?.aei_causes_json?.asset_fit || '',
        assetFitForUseNotes: details?.why_did_happen?.aei_causes_json?.asset_fit_detail || '',
        equipmentConditionDetails: details?.why_did_happen?.aei_causes_json?.equipmentConditionDetails || '',
        maintenanceStatusDetails: details?.why_did_happen?.aei_causes_json?.maintenanceStatusDetails || '',

        // op_causes_json
        proceduresIssue: details?.why_did_happen?.op_causes_json?.procedures_issue || '',
        proceduresIssueDetail: details?.why_did_happen?.op_causes_json?.procedures_issue_detail || '',
        communicationFailure: details?.why_did_happen?.op_causes_json?.communication_failure || '',
        communicationWho: details?.why_did_happen?.op_causes_json?.communication_who || '',
        communicationWhat: details?.why_did_happen?.op_causes_json?.communication_what || '',
        externalParties: details?.why_did_happen?.op_causes_json?.external_party || '',
        externalPartiesDetail: details?.why_did_happen?.op_causes_json?.external_party_detail || '',
        securityBreach: details?.why_did_happen?.op_causes_json?.security_breach || '',
        securityBreachDetail: details?.why_did_happen?.op_causes_json?.security_breach_detail || '',
        thirdPartyError: details?.why_did_happen?.op_causes_json?.third_party_error || '',
        thirdPartyErrorDetail: details?.why_did_happen?.op_causes_json?.third_party_error_detail || '',
        languageBarrier: details?.why_did_happen?.op_causes_json?.language_barrier || '',
        languageBarrierNotes: details?.why_did_happen?.op_causes_json?.language_barrier_notes || '',

        // he_causes_json
        fatigueLevel: details?.why_did_happen?.he_causes_json?.fatigue_level || '',
        fatigueDetails: details?.why_did_happen?.he_causes_json?.fatigue_details || '',
        fitnessForDuty: details?.why_did_happen?.he_causes_json?.fitness_for_duty || '',
        fitnessForDutyExplain: details?.why_did_happen?.he_causes_json?.fitness_for_duty_explain || '',
        illHealthRecent1: details?.why_did_happen?.he_causes_json?.ill_health_1 || '',
        illHealthRecentDetail1: details?.why_did_happen?.he_causes_json?.ill_health_detail_1 || '',
        illHealthRecent2: details?.why_did_happen?.he_causes_json?.ill_health_2 || '',
        illHealthRecentDetail2: details?.why_did_happen?.he_causes_json?.ill_health_detail_2 || '',
        medicationUse: details?.why_did_happen?.he_causes_json?.medication_use || '',
        medicationUseDetail: details?.why_did_happen?.he_causes_json?.medication_use_detail || '',
        psychologicalStress: details?.why_did_happen?.he_causes_json?.psychological_stress || '',
        psychologicalStressDetail: details?.why_did_happen?.he_causes_json?.psychological_stress_detail || '',
        shiftPattern: details?.why_did_happen?.he_causes_json?.shift_pattern || '',
        shiftPatternDetail: details?.why_did_happen?.he_causes_json?.shift_pattern_detail || '',
        trainingAdequacy: details?.why_did_happen?.he_causes_json?.training_adequacy || '',
        trainingAdequacyDetail: details?.why_did_happen?.he_causes_json?.training_adequacy_detail || '',
        supervisionLevel: details?.why_did_happen?.he_causes_json?.supervision_level || '',
        supervisionLevelDetail: details?.why_did_happen?.he_causes_json?.supervision_level_detail || '',
        complianceWithSOP: details?.why_did_happen?.he_causes_json?.compliance_with_sop || '',
        complianceWithSOPDetail: details?.why_did_happen?.he_causes_json?.compliance_with_sop_detail || '',
    };

    useEffect(() => {
        if (details?.why_did_happen) {
            formik.setValues({
                id: details?.why_did_happen?.id || '',
                weather: details?.why_did_happen?.se_causes_json?.weather || '',
                visibility: details?.why_did_happen?.se_causes_json?.visibility || '',
                lightingAdequacy: details?.why_did_happen?.se_causes_json?.lightingAdequacy || '',
                noiseDistraction: details?.why_did_happen?.se_causes_json?.noiseDistraction || '',
                timeOfDay: details?.why_did_happen?.se_causes_json?.timeOfDay || '',
                trafficActivity: details?.why_did_happen?.se_causes_json?.trafficActivity || '',
                emergencyOngoing: details?.why_did_happen?.se_causes_json?.emergencyOngoing || '',
                emergencyDetails: details?.why_did_happen?.se_causes_json?.emergencyDetails || '',

                // aei_causes_json
                equipmentCondition: details?.why_did_happen?.aei_causes_json?.equipment_condition || '',
                maintenanceStatus: details?.why_did_happen?.aei_causes_json?.maintenance_status || '',
                assetType: details?.why_did_happen?.aei_causes_json?.asset_type || '',
                assetId: details?.why_did_happen?.aei_causes_json?.asset_tag || '',
                knownDefects: details?.why_did_happen?.aei_causes_json?.known_defects || '',
                knownDefectsDetails: details?.why_did_happen?.aei_causes_json?.known_defects_detail || '',
                assetFitForUse: details?.why_did_happen?.aei_causes_json?.asset_fit || '',
                assetFitForUseNotes: details?.why_did_happen?.aei_causes_json?.asset_fit_detail || '',
                equipmentConditionDetails: details?.why_did_happen?.aei_causes_json?.equipmentConditionDetails || '',
                maintenanceStatusDetails: details?.why_did_happen?.aei_causes_json?.maintenanceStatusDetails || '',
                // op_causes_json
                proceduresIssue: details?.why_did_happen?.op_causes_json?.procedures_issue || '',
                proceduresIssueDetail: details?.why_did_happen?.op_causes_json?.procedures_issue_detail || '',
                communicationFailure: details?.why_did_happen?.op_causes_json?.communication_failure || '',
                communicationWho: details?.why_did_happen?.op_causes_json?.communication_who || '',
                communicationWhat: details?.why_did_happen?.op_causes_json?.communication_what || '',
                externalParties: details?.why_did_happen?.op_causes_json?.external_party || '',
                externalPartiesDetail: details?.why_did_happen?.op_causes_json?.external_party_detail || '',
                securityBreach: details?.why_did_happen?.op_causes_json?.security_breach || '',
                securityBreachDetail: details?.why_did_happen?.op_causes_json?.security_breach_detail || '',
                thirdPartyError: details?.why_did_happen?.op_causes_json?.third_party_error || '',
                thirdPartyErrorDetail: details?.why_did_happen?.op_causes_json?.third_party_error_detail || '',
                languageBarrier: details?.why_did_happen?.op_causes_json?.language_barrier || '',
                languageBarrierNotes: details?.why_did_happen?.op_causes_json?.language_barrier_notes || '',

                // he_causes_json
                fatigueLevel: details?.why_did_happen?.he_causes_json?.fatigue_level || '',
                fatigueDetails: details?.why_did_happen?.he_causes_json?.fatigue_details || '',
                fitnessForDuty: details?.why_did_happen?.he_causes_json?.fitness_for_duty || '',
                fitnessForDutyExplain: details?.why_did_happen?.he_causes_json?.fitness_for_duty_explain || '',
                illHealthRecent1: details?.why_did_happen?.he_causes_json?.ill_health_1 || '',
                illHealthRecentDetail1: details?.why_did_happen?.he_causes_json?.ill_health_detail_1 || '',
                illHealthRecent2: details?.why_did_happen?.he_causes_json?.ill_health_2 || '',
                illHealthRecentDetail2: details?.why_did_happen?.he_causes_json?.ill_health_detail_2 || '',
                medicationUse: details?.why_did_happen?.he_causes_json?.medication_use || '',
                medicationUseDetail: details?.why_did_happen?.he_causes_json?.medication_use_detail || '',
                psychologicalStress: details?.why_did_happen?.he_causes_json?.psychological_stress || '',
                psychologicalStressDetail: details?.why_did_happen?.he_causes_json?.psychological_stress_detail || '',
                shiftPattern: details?.why_did_happen?.he_causes_json?.shift_pattern || '',
                shiftPatternDetail: details?.why_did_happen?.he_causes_json?.shift_pattern_detail || '',
                trainingAdequacy: details?.why_did_happen?.he_causes_json?.training_adequacy || '',
                trainingAdequacyDetail: details?.why_did_happen?.he_causes_json?.training_adequacy_detail || '',
                supervisionLevel: details?.why_did_happen?.he_causes_json?.supervision_level || '',
                supervisionLevelDetail: details?.why_did_happen?.he_causes_json?.supervision_level_detail || '',
                complianceWithSOP: details?.why_did_happen?.he_causes_json?.compliance_with_sop || '',
                complianceWithSOPDetail: details?.why_did_happen?.he_causes_json?.compliance_with_sop_detail || '',
            });
        }
    }, [details]);

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema: "",
        onSubmit: async (values) => {
            const payload = {
                id: values.id,
                incident_header_id: details.header_id,
                se_causes_json: {
                    weather: values.weather,
                    visibility: values.visibility,
                    lightingAdequacy: values.lightingAdequacy,
                    noiseDistraction: values.noiseDistraction,
                    timeOfDay: values.timeOfDay,
                    trafficActivity: values.trafficActivity,
                    emergencyOngoing: values.emergencyOngoing,
                    emergencyDetails: values.emergencyDetails,
                },

                aei_causes_json: {
                    equipment_condition: values.equipmentCondition,
                    maintenance_status: values.maintenanceStatus,
                    asset_type: values.assetType,
                    asset_tag: values.assetId,
                    known_defects: values.knownDefects,
                    known_defects_detail: values.knownDefectsDetails,
                    asset_fit: values.assetFitForUse,
                    asset_fit_detail: values.assetFitForUseNotes,
                    equipmentConditionDetails: values.equipmentConditionDetails,
                    maintenanceStatusDetails: values.maintenanceStatusDetails,
                },

                op_causes_json: {
                    procedures_issue: values.proceduresIssue,
                    procedures_issue_detail: values.proceduresIssueDetail,
                    communication_failure: values.communicationFailure,
                    communication_who: values.communicationWho,
                    communication_what: values.communicationWhat,
                    external_party: values.externalParties,
                    external_party_detail: values.externalPartiesDetail,
                    security_breach: values.securityBreach,
                    security_breach_detail: values.securityBreachDetail,
                    third_party_error: values.thirdPartyError,
                    third_party_error_detail: values.thirdPartyErrorDetail,
                    language_barrier: values.languageBarrier,
                    language_barrier_notes: values.languageBarrierNotes,
                },

                he_causes_json: {
                    fatigue_level: values.fatigueLevel,
                    fatigue_details: values.fatigueDetails,
                    fitness_for_duty: values.fitnessForDuty,
                    fitness_for_duty_explain: values.fitnessForDutyExplain,
                    ill_health_1: values.illHealthRecent1,
                    ill_health_detail_1: values.illHealthRecentDetail1,
                    ill_health_2: values.illHealthRecent2,
                    ill_health_detail_2: values.illHealthRecentDetail2,
                    medication_use: values.medicationUse,
                    medication_use_detail: values.medicationUseDetail,
                    psychological_stress: values.psychologicalStress,
                    psychological_stress_detail: values.psychologicalStressDetail,
                    shift_pattern: values.shiftPattern,
                    shift_pattern_detail: values.shiftPatternDetail,
                    training_adequacy: values.trainingAdequacy,
                    training_adequacy_detail: values.trainingAdequacyDetail,
                    supervision_level: values.supervisionLevel,
                    supervision_level_detail: values.supervisionLevelDetail,
                    compliance_with_sop: values.complianceWithSOP,
                    compliance_with_sop_detail: values.complianceWithSOPDetail,
                },
            };

            setLoadings(true);
            try {
                const res = await postWhyDidItHappen(payload);
                console.log("res", res.data);
                toast.success(res.data.message);
                postUpdateData();
            } catch (error) {
                toast.error(error?.response?.data?.message || 'Something went wrong');
            } finally {
                setLoadings(false);
            }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched, } = formik;

    useEffect(() => {
        let parsedWhy = [];

        try {
            // If it's a JSON string, parse it
            parsedWhy = JSON.parse(details?.why || '[]');
            if (!Array.isArray(parsedWhy)) parsedWhy = [];
        } catch (e) {
            parsedWhy = [];
        }

        const htmlList = `<ul>${parsedWhy.map(item => `<li>${item}</li>`).join('')}</ul>`;
        setFieldValue('why', htmlList);
    }, [details, setFieldValue]);


    return (
        <>
            <div className="GroupList fieldset">
                <div className='toggle-button'>
                    <h2 className="listTitle">Why did it happen</h2>
                    <div className="btnColaps">
                        <FaChevronUp />
                    </div>
                </div>
                <div className="formsBox subFilds">
                    <form onSubmit={handleSubmit} autoComplete="off">
                        {details?.why == 'undefined' || details?.why == '' ? null : (
                            <div className="form-box">
                                <div className="fieldset intl">
                                    <h1>Initial Why did it happen</h1>
                                    <div className="formsBox">
                                        <div className="form-group">
                                            <div dangerouslySetInnerHTML={{ __html: values.why }}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="fieldset">
                            <h1>Situational / Environmental Causes</h1>
                            <div className="formsBox">
                                <div className="row">
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Weather Conditions</label>
                                            <div className="radiogroups">
                                                {["Clear", "Rain", "Fog", "Storm", "Other"].map(
                                                    (option) => (
                                                        <div className="radiobox" key={option}>
                                                            <label>
                                                                {option}
                                                                <input
                                                                    type="radio"
                                                                    name="weather"
                                                                    value={option}
                                                                    checked={values.weather === option}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Visibility</label>
                                            <div className="radiogroups">
                                                {["Good", "Moderate", "Poor"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="visibility"
                                                                value={option}
                                                                checked={values.visibility === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Lighting Adequacy</label>
                                            <div className="radiogroups">
                                                {["Sufficient", "Insufficient"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="lightingAdequacy" // <-- Formik field name
                                                                value={option}
                                                                checked={values.lightingAdequacy === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Noise / Distraction</label>

                                            <div className="radiogroups">
                                                {["None", "Moderate", "Excessive"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="noiseDistraction"
                                                                value={option}
                                                                checked={values.noiseDistraction === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Time of Day</label>
                                            <div className="radiogroups">
                                                {["Day", "Night", "Twilight"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="timeOfDay"
                                                                value={option}
                                                                checked={values.timeOfDay === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Traffic / Activity Level</label>
                                            <div className="radiogroups">
                                                {["Normal", "High", "Excessive"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="trafficActivity"
                                                                value={option}
                                                                checked={values.trafficActivity === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Emergency or Unusual Ops Ongoing?</label>
                                            <div className="radiogroups">
                                                {["Yes", "No"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="emergencyOngoing"
                                                                value={option}
                                                                checked={values.emergencyOngoing === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>

                                            <input
                                                className="form-control"
                                                name="emergencyDetails"
                                                placeholder="details"
                                                value={values.emergencyDetails}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="fieldset">
                            <h1>Asset / equipment / infrastructure causes</h1>

                            <div className="formsBox">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Equipment Condition</label>
                                            <div className="radiogroups">
                                                {["Serviceable", "Defective", "Unknown"].map(
                                                    (option) => (
                                                        <div className="radiobox" key={option}>
                                                            <label>
                                                                {option}
                                                                <input
                                                                    type="radio"
                                                                    name="equipmentCondition"
                                                                    value={option}
                                                                    checked={
                                                                        values.equipmentCondition === option
                                                                    }
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                            <input
                                                className="form-control"
                                                name="equipmentConditionDetails"
                                                value={values.equipmentConditionDetails}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                placeholder="details"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Maintenance Status</label>
                                            <div className="radiogroups">
                                                {["Up to Date", "Overdue", "Unknown"].map(
                                                    (option) => (
                                                        <div className="radiobox" key={option}>
                                                            <label>
                                                                {option}
                                                                <input
                                                                    type="radio"
                                                                    name="maintenanceStatus"
                                                                    value={option}
                                                                    checked={
                                                                        values.maintenanceStatus === option
                                                                    }
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                            <input
                                                className="form-control"
                                                name="maintenanceStatusDetails"
                                                value={values.maintenanceStatusDetails}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                placeholder="details"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Asset Type</label>
                                            <input
                                                className="form-control"
                                                name="assetType"
                                                value={values.assetType}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                placeholder="e.g., Vehicle, Lighting, Perimeter Fence, Building, Baggage System"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Asset ID / Tag</label>
                                            <input
                                                className="form-control"
                                                name="assetId"
                                                value={values.assetId}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                placeholder="details"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Known Defects or Reports</label>
                                            <div className="radiogroups">
                                                {["Yes", "No"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="knownDefects"
                                                                value={option}
                                                                checked={values.knownDefects === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <input
                                                className="form-control"
                                                name="knownDefectsDetails"
                                                value={values.knownDefectsDetails}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                placeholder="describe"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Was Asset Fit for Use?</label>
                                            <div className="radiogroups">
                                                {["Yes", "No"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="assetFitForUse"
                                                                value={option}
                                                                checked={values.assetFitForUse === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <input
                                                className="form-control"
                                                name="assetFitForUseNotes"
                                                value={values.assetFitForUseNotes}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                placeholder="notes"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="fieldset">
                            <h1>Other Possible Causes</h1>
                            <div className="formsBox">
                                <div className="row">
                                    {/* Procedures / SOP Issues */}
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Procedures / SOP Issues</label>
                                            <div className="radiogroups">
                                                {["Yes", "No"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="proceduresIssue"
                                                                value={option}
                                                                checked={values.proceduresIssue === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <input
                                                className="form-control"
                                                name="proceduresIssueDetail"
                                                placeholder="describe"
                                                value={values.proceduresIssueDetail}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>

                                    {/* Communication Failure */}
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Communication Failure</label>
                                            <div className="radiogroups">
                                                {["Yes", "No"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="communicationFailure"
                                                                value={option}
                                                                checked={
                                                                    values.communicationFailure === option
                                                                }
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <input
                                                className="form-control"
                                                name="communicationWho"
                                                placeholder="Who"
                                                value={values.communicationWho}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />

                                            <input
                                                className="form-control"
                                                name="communicationWhat"
                                                placeholder="What"
                                                value={values.communicationWhat}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>

                                    {/* External Parties Involved */}
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>External Parties Involved</label>
                                            <div className="radiogroups">
                                                {["Airline", "Contractor", "Visitor", "Other"].map(
                                                    (option) => (
                                                        <div className="radiobox" key={option}>
                                                            <label>
                                                                {option}
                                                                <input
                                                                    type="radio"
                                                                    name="externalParties"
                                                                    value={option}
                                                                    checked={values.externalParties === option}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                            <input
                                                className="form-control"
                                                name="externalPartiesDetail"
                                                placeholder="details"
                                                value={values.externalPartiesDetail}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>

                                    {/* Security Breach */}
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Security Breach</label>
                                            <div className="radiogroups">
                                                {["Yes", "No"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="securityBreach"
                                                                value={option}
                                                                checked={values.securityBreach === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <input
                                                className="form-control"
                                                name="securityBreachDetail"
                                                placeholder="details"
                                                value={values.securityBreachDetail}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>

                                    {/* Third-Party Errors */}
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Third-Party Errors</label>
                                            <div className="radiogroups">
                                                {["Yes", "No"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="thirdPartyError"
                                                                value={option}
                                                                checked={values.thirdPartyError === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <input
                                                className="form-control"
                                                name="thirdPartyErrorDetail"
                                                placeholder="describe"
                                                value={values.thirdPartyErrorDetail}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>

                                    {/* Cultural / Language Barrier */}
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Cultural / Language Barrier</label>
                                            <div className="radiogroups">
                                                {["Yes", "No"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="languageBarrier"
                                                                value={option}
                                                                checked={values.languageBarrier === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <input
                                                className="form-control"
                                                name="languageBarrierNotes"
                                                placeholder="notes"
                                                value={values.languageBarrierNotes}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="fieldset">
                            <h1>Human Element Causes</h1>

                            <div className="formsBox">
                                <div className="row">
                                    {/* 1. Fatigue Level */}
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Fatigue Level</label>
                                            <div className="radiogroups">
                                                {["None", "Low", "Moderate", "Severe"].map(
                                                    (option) => (
                                                        <div className="radiobox" key={option}>
                                                            <label>
                                                                {option}
                                                                <input
                                                                    type="radio"
                                                                    name="fatigueLevel"
                                                                    value={option}
                                                                    checked={values.fatigueLevel === option}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="fatigueDetails"
                                                placeholder="details"
                                                value={values.fatigueDetails}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>

                                    {/* 2. Fitness for Duty */}
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Fitness for Duty</label>
                                            <div className="radiogroups">
                                                {["Fit", "Not Fit"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="fitnessForDuty"
                                                                value={option}
                                                                checked={values.fitnessForDuty === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="fitnessForDutyExplain"
                                                placeholder="explain"
                                                value={values.fitnessForDutyExplain}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>

                                    {/* 3. Ill Health / Recent Medical Issues #1 */}
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Ill Health / Recent Medical Issues</label>
                                            <div className="radiogroups">
                                                {["Yes", "No"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="illHealthRecent1"
                                                                value={option}
                                                                checked={values.illHealthRecent1 === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="illHealthRecentDetail1"
                                                placeholder="details"
                                                value={values.illHealthRecentDetail1}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>

                                    {/* 4. Ill Health / Recent Medical Issues #2 */}
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Ill Health / Recent Medical Issues</label>
                                            <div className="radiogroups">
                                                {["Yes", "No"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="illHealthRecent2"
                                                                value={option}
                                                                checked={values.illHealthRecent2 === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="illHealthRecentDetail2"
                                                placeholder="details"
                                                value={values.illHealthRecentDetail2}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>

                                    {/* 5. Use of Medication / Substances */}
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Use of Medication / Substances</label>
                                            <div className="radiogroups">
                                                {["Yes", "No"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="medicationUse"
                                                                value={option}
                                                                checked={values.medicationUse === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="medicationUseDetail"
                                                placeholder="details"
                                                value={values.medicationUseDetail}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>

                                    {/* 6. Psychological Stress / Personal Issues */}
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Psychological Stress / Personal Issues</label>
                                            <div className="radiogroups">
                                                {["Yes", "No"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="psychologicalStress"
                                                                value={option}
                                                                checked={
                                                                    values.psychologicalStress === option
                                                                }
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="psychologicalStressDetail"
                                                placeholder="details"
                                                value={values.psychologicalStressDetail}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>

                                    {/* 7. Recent Shift Pattern / Overtime */}
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Recent Shift Pattern / Overtime</label>
                                            <div className="radiogroups">
                                                {["Standard", "Extended", "Excessive"].map(
                                                    (option) => (
                                                        <div className="radiobox" key={option}>
                                                            <label>
                                                                {option}
                                                                <input
                                                                    type="radio"
                                                                    name="shiftPattern"
                                                                    value={option}
                                                                    checked={values.shiftPattern === option}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="shiftPatternDetail"
                                                placeholder="hours worked"
                                                value={values.shiftPatternDetail}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>

                                    {/* 8. Training Adequacy */}
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Training Adequacy</label>
                                            <div className="radiogroups">
                                                {["Fully", "Partially", "Not"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="trainingAdequacy"
                                                                value={option}
                                                                checked={values.trainingAdequacy === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="trainingAdequacyDetail"
                                                placeholder="details"
                                                value={values.trainingAdequacyDetail}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>

                                    {/* 9. Supervision Level */}
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Supervision Level</label>
                                            <div className="radiogroups">
                                                {["Adequate", "Inadequate", "None"].map((option) => (
                                                    <div className="radiobox" key={option}>
                                                        <label>
                                                            {option}
                                                            <input
                                                                type="radio"
                                                                name="supervisionLevel"
                                                                value={option}
                                                                checked={values.supervisionLevel === option}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="supervisionLevelDetail"
                                                placeholder="details"
                                                value={values.supervisionLevelDetail}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>

                                    {/* 10. Compliance with SOPs */}
                                    <div className="col-md-4 rd-100">
                                        <div className="form-group">
                                            <label>Compliance with SOPs</label>
                                            <div className="radiogroups">
                                                {["Full", "Partial", "Non-compliant"].map(
                                                    (option) => (
                                                        <div className="radiobox" key={option}>
                                                            <label>
                                                                {option}
                                                                <input
                                                                    type="radio"
                                                                    name="complianceWithSOP"
                                                                    value={option}
                                                                    checked={
                                                                        values.complianceWithSOP === option
                                                                    }
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="complianceWithSOPDetail"
                                                placeholder="details"
                                                value={values.complianceWithSOPDetail}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="button-boxs grid pb-2">
                            <button type="submit" className="btn btn-orange">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
            {isLoadings ? <Loader /> : null}
        </>
    )
}

export default WhyDidItHappen